import { SalesChannel } from './model';

export const SOURCE_SYSTEMS = ['Salesforce'] as const;
export type SourceSystem = (typeof SOURCE_SYSTEMS)[number];
export const DEFAULT_SOURCE_SYSTEM: SourceSystem = 'Salesforce';

export interface SourceSystemLostReasonDto {
  id?: string | null;
  lostReasonId: string;
  sourceSystem: string;
  englishLabel: string;
  germanLabel: string;
  isActive: boolean;
  lostReasonEnglishLabel?: string | null;
  lostReasonGermanLabel?: string | null;
}

export interface HandoverSystemDto {
  id?: string | null;
  keyword: string;
  description: string;
  isActive: boolean;
}

export interface LostReasonDto {
  id?: string | null;
  code?: string | null;
  englishLabel: string;
  germanLabel: string;
  isActive: boolean;
}

export interface LostReasonChannelConfigurationAdminDto {
  id?: string | null;
  salesChannel: SalesChannel;
  name: string;
  description?: string | null;
  isActive: boolean;
}

export interface LostReasonChannelGroupAdminDto {
  id: string;
  configurationId: string;
  configurationName: string;
  configurationIsActive: boolean;
  salesChannel: SalesChannel;
  groupName: string;
  outcomeKey: string;
  handoverSystemKeyword?: string | null;
  handoverSystemDescription?: string | null;
  handoverSystemIsActive?: boolean | null;
  isActive: boolean;
  createdDate?: string | null;
  lostReasons: LostReasonDto[];
}

export interface LostReasonChannelGroupSaveDto {
  id?: string | null;
  configurationId: string;
  groupName: string;
  outcomeKey: string;
  handoverSystemKeyword?: string | null;
  isActive: boolean;
  lostReasonIds: string[];
}

export interface LostReasonChannelAdminBundleDto {
  configurations: LostReasonChannelConfigurationAdminDto[];
  groups: LostReasonChannelGroupAdminDto[];
}

export interface LostReasonAssignmentReasonDto {
  id: string;
  code?: string | null;
  englishLabel: string;
  germanLabel: string;
}

export interface LostReasonAssignmentGroupDto {
  id: string;
  outcomeKey: string;
  groupName: string;
  handoverSystemKeyword?: string | null;
  reasons: LostReasonAssignmentReasonDto[];
}

export interface LostReasonAssignmentConfigDto {
  salesChannel: SalesChannel;
  description?: string | null;
  groups: LostReasonAssignmentGroupDto[];
}

export const HANDOVER_TO_OTHER_SYSTEM_OUTCOME_KEY = 'HandoverToOtherSystem';

export const LOST_REASON_OUTCOME_KEYS = [
  'CustomerSentToRevision',
  'CustomerLostWithoutSellerInfoOptin',
  'CustomerLostWithSellerInfoOptin',
  HANDOVER_TO_OTHER_SYSTEM_OUTCOME_KEY,
  'DefaultSalesChannelBehavior',
] as const;

export type LostReasonOutcomeKey = (typeof LOST_REASON_OUTCOME_KEYS)[number];

export const LOST_REASON_OUTCOME_LABELS: Record<LostReasonOutcomeKey, string> = {
  CustomerSentToRevision: 'Send to revision',
  CustomerLostWithoutSellerInfoOptin: 'Customer lost (without seller info opt-in)',
  CustomerLostWithSellerInfoOptin: 'Customer lost (with seller info opt-in)',
  HandoverToOtherSystem: 'Handover to other system',
  DefaultSalesChannelBehavior: 'Default (legacy channel behavior)',
};
